import React, { Component } from "react";
import { TextBtn, BlueBtn } from "components/Controls";
import { LogoView } from "components/DataDisplay";
import { connect } from "react-redux";
import {
  selectedOfferSelector,
  userInfoSelector,
  loadingSelector,
} from "../selectors";
import { confirmOffer, backToOffers } from "../actions";
import { BuyoutInfo, OfferView } from "components/DataDisplay";
import { Field, reduxForm } from "redux-form";
import { formValueSelector } from "redux-form";
import { buildOfferData } from "containers/MultistepForm/helpers";
import "./styles.scss";
const selector = formValueSelector("confirmation_step_form");

class ConfirmationStep extends Component {
  renderOffer = () => {
    const { selectedOffer } = this.props;

    return (
      <div className="step5__offer offer-wrapper flex flex--column flex__align--center">
        <div className="step5__offer-logo ">
          <LogoView provider={selectedOffer.specific_provider_name} />
        </div>
        <span className="step5__offer-title font-center">
          <strong>HERE’S THE BREAKDOWN OF YOUR PAYMENT PLAN</strong>
        </span>
        <div className="step5__offer-plan flex flex--wrap application-offer">
          <OfferView offerData={buildOfferData(selectedOffer)} />
        </div>

        {selectedOffer.type == "Lease to Loan" && selectedOffer.buyout && (
          <BuyoutInfo
            title={"Early Buyout Option"}
            text={`Payoff in 90 days and only pay a ${selectedOffer.buyout_rate}% fee`}
          />
        )}
        {selectedOffer.specific_provider_name == "greenwave" && (
          <BuyoutInfo
            title={"120 Day Payment Option"}
            text={`Simply pay the cash price within 100 days after the lease is completed.`}
          />
        )}
      </div>
    );
  };

  handleContinueButton = () => {
    this.props.confirmOffer();
  };

  handleBackButton = () => {
    const { backToOffers } = this.props;
    backToOffers();
  };

  render() {
    const { selectedOffer, userInfo } = this.props;
    const { loading } = this.props;

    if (!selectedOffer) {
      return <p className="text-center">No offer was selected.</p>;
    }
    return (
      <div className="step5__content flex--column">
        <div className="flex flex--column-reverse">
          <TextBtn
            customClass="step5__change-btn"
            onClick={this.handleBackButton}
          >
            see more
          </TextBtn>
          <h2 className="subtitle font-center">
            Congratulations, {userInfo.firstName}!
          </h2>
        </div>

        {this.renderOffer()}

        <BlueBtn
          customClass="step5__submit-btn"
          onClick={this.handleContinueButton}
          loading={loading}
        >
          CONTINUE TO LAST STEP
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedOffer: selectedOfferSelector()(state),
  // selectedOfferAlreadyAccepted: selectedOfferAcceptedSelector()(state),
  userInfo: userInfoSelector()(state),
  loading: loadingSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    confirmOffer: () => dispatch(confirmOffer()),
    backToOffers: () => dispatch(backToOffers()),
  };
};

ConfirmationStep = connect(
  mapStateToProps,
  mapDistpatchToProps
)(ConfirmationStep);
ConfirmationStep = reduxForm({
  form: "confirmation_step_form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ConfirmationStep);

export default ConfirmationStep;
